import React from 'react';

import { createQuickInsertMatcher } from '@atlaskit/editor-common/quick-insert/create-quick-insert-matcher';
import { BLOCK_TEMPLATES_SECTION } from '@atlaskit/editor-common/quick-insert/keys';
import { TEMPLATE_GALLERY_MENU_RANK } from '@atlaskit/editor-common/quick-insert/snippet-menu-rank';
import type { RegisterMenuItem } from '@atlaskit/editor-ui-control-model/types';

import type { SnippetsPlugin } from '../../snippetsPluginType';
import { getTemplateGalleryQuickInsertItem } from './getTemplateGalleryQuickInsertItem';
import { TemplateGalleryQuickInsertMenuItem } from './TemplateGalleryQuickInsertMenuItem';

type Params = {
	api: Parameters<SnippetsPlugin>[0]['api'];
	onOpenTemplateGallery: () => void;
};

export const getTemplateGalleryQuickInsertComponents = ({
	api,
	onOpenTemplateGallery,
}: Params): RegisterMenuItem[] => [
	{
		key: 'block-template',
		type: 'menu-item',
		parents: [
			{
				key: BLOCK_TEMPLATES_SECTION.key,
				type: BLOCK_TEMPLATES_SECTION.type,
				rank: TEMPLATE_GALLERY_MENU_RANK,
			},
		],
		match: createQuickInsertMatcher(({ formatMessage }) => {
			const item = getTemplateGalleryQuickInsertItem(onOpenTemplateGallery, { formatMessage });
			return {
				description: item.description,
				keywords: item.keywords,
				title: item.title,
			};
		}),
		component: () => (
			<TemplateGalleryQuickInsertMenuItem onOpenTemplateGallery={onOpenTemplateGallery} />
		),
	},
];
